import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  d: "M4.588 8.863c0-.21-.155-.38-.346-.38h-.896c-.191 0-.346.17-.346.38s.155.38.346.38h.896c.191 0 .346-.17.346-.38Zm.413-4.007a.325.325 0 0 0-.49 0 .406.406 0 0 0 0 .537l.635.696a.33.33 0 0 0 .244.11.33.33 0 0 0 .245-.11.406.406 0 0 0 0-.537L5 4.856Zm6.812 0a.324.324 0 0 0-.488 0l-.634.696a.405.405 0 0 0 0 .535.33.33 0 0 0 .244.11.33.33 0 0 0 .244-.11l.634-.696a.405.405 0 0 0 0-.535ZM8.186 3.197h-.024a.316.316 0 0 0-.046.003l-.023.004a.373.373 0 0 0-.276.372v.984c0 .201.142.366.322.379h.023c.191 0 .346-.17.346-.379v-.984a.376.376 0 0 0-.252-.365l-.024-.007a.315.315 0 0 0-.046-.007Zm-1.981 7.062a3.03 3.03 0 0 1 .894.086c.475-1.302 1.787-2.243 3.34-2.272l.036-.001.036-.001c.15 0 .299.008.445.025-.243-1.245-1.323-2.184-2.618-2.184-1.474 0-2.67 1.215-2.67 2.715 0 .612.2 1.178.537 1.632Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M7.066 16.803c-1.464 0-2.65-1.242-2.65-2.775s1.186-2.775 2.65-2.775c.237 0 .465.036.684.096.446-1.38 1.681-2.378 3.143-2.408l.034-.002h.033c1.732 0 3.16 1.36 3.364 3.115a2.19 2.19 0 0 1 .391-.037c1.262 0 2.285 1.071 2.285 2.393 0 1.322-1.023 2.393-2.285 2.393H7.066Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=PartlySunnyIcon20.js.map